export const TIMEZONE_PST = 'America/Los_Angeles';

export default [{
  label: 'Pacific Time',
  value: TIMEZONE_PST,
}, {
  label: 'Mountain Time',
  value: 'America/Denver',
}, {
  label: 'Central Time',
  value: 'America/Chicago',
}, {
  label: 'Eastern Time',
  value: 'America/Detroit',
}, {
  label: 'Alaska Time',
  value: 'America/Anchorage',
}, {
  label: 'Hawaii Time',
  value: 'Pacific/Honolulu',
}, {
  label: 'Atlantic Time',
  value: 'America/Puerto_Rico',
}];
